import React from 'react';
import { Col, Container, Form, Row } from 'react-bootstrap';
import ExecutionScopeForm from '../../../elements/common/execution/ExecutionScopeForm';
import { techLayerFilters } from '../../../../static-data/DropdownOptions';
import useExecutionScope from '../../../../hooks/useExecutionScope';
import { useParams } from 'react-router-dom';
import MultiSelectDropdown from '../../../elements/MultiSelectDropdown';

const TestCaseFilterForm = ({
  formData,
  setFormData,
  statuses = [],
  priorities = [],
  modules = [],
  projectUsers = [],
  labels = [],
  loading,
  testSuites = [],
}) => {
  const { projectId } = useParams();
  const { isScopeDefined } = useExecutionScope(projectId);
  const projectUserOptions = projectUsers.map((user) => ({
    id: user.id,
    name: user.full_name,
  }));

  // const handleChange = (e) => {
  //   const { id, value, type, checked } = e.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [id]: type === 'checkbox' ? checked : value,
  //   }));
  // };

  const handleDropdownChange = (id, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [id]: Array.isArray(value) ? value : value === '' ? null : value,
    }));
  };

  const handleAdvanceFilters = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  return (
    <div>
      {loading ? (
        'Loading...'
      ) : (
        <Form>
          <Container fluid className="p-0">
            <Row className="mt-2">
              <Col>
                <Form.Group controlId="status">
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    as="select"
                    value={formData.status}
                    onChange={(e) =>
                      handleDropdownChange('status', e.target.value)
                    }
                    className="form-input">
                    <option value="All">All</option>
                    {statuses?.map((status) => (
                      <option key={status.id} value={status.id}>
                        {status.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="priority">
                  <Form.Label>Priority</Form.Label>
                  <Form.Select
                    as="select"
                    value={formData?.priority}
                    onChange={(e) =>
                      handleDropdownChange('priority', e.target.value)
                    }
                    className="form-input">
                    <option value="All">All</option>
                    {priorities?.map((priority) => (
                      <option key={priority.id} value={priority.id}>
                        {priority.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="owner">
                  <Form.Label>Author</Form.Label>
                  <MultiSelectDropdown
                    options={projectUserOptions}
                    selectedValues={formData?.owner || []}
                    maxSelections={projectUserOptions?.length}
                    onChange={(selectedValues) =>
                      handleDropdownChange('owner', selectedValues)
                    }
                    placeholder=""
                    name='users'
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col md={4}>
                <Form.Group controlId="module">
                  <Form.Label>Project Module</Form.Label>
                  <MultiSelectDropdown
                    options={modules}
                    selectedValues={formData?.module || []}
                    maxSelections={modules?.length}
                    onChange={(selectedValues) =>
                      handleDropdownChange('module', selectedValues)
                    }
                    placeholder=""
                    name='modules'
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="technologyLayer">
                  <Form.Label>Technology Layer</Form.Label>
                  <Form.Select
                    as="select"
                    value={formData.technologyLayer || ''}
                    onChange={(e) =>
                      handleDropdownChange('technologyLayer', e.target.value)
                    }
                    className="form-input">
                    {techLayerFilters?.map((tech) => (
                      <option key={tech} value={tech}>
                        {tech}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="labels">
                  <Form.Label>Labels</Form.Label>
                   <MultiSelectDropdown
                    options={labels}
                    selectedValues={formData?.labels || []}
                    maxSelections={labels.length}
                    onChange={(selectedValues) => handleDropdownChange('labels', selectedValues)}
                    placeholder=""
                    name='labels'
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md={4}>
                <Form.Group controlId="status">
                  <Form.Label>Candidate for Automation</Form.Label>
                  <Form.Select
                    as="select"
                    value={formData.isAutomationNeeded}
                    onChange={(e) =>
                      handleDropdownChange('isAutomationNeeded', e.target.value)
                    }
                    className="form-input">
                    <option value="All">All</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="status">
                  <Form.Label>Is Automated?</Form.Label>
                  <Form.Select
                    as="select"
                    value={formData.isAutomated}
                    onChange={(e) =>
                      handleDropdownChange('isAutomated', e.target.value)
                    }
                    className="form-input">
                    <option value="All">All</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="labels">
                  <Form.Label>Test suites</Form.Label>
                   <MultiSelectDropdown
                    options={testSuites}
                    selectedValues={formData?.testSuites || []}
                    maxSelections={testSuites.length}
                    onChange={(selectedValues) => handleDropdownChange('testSuites', selectedValues)}
                    placeholder=""
                    name='test suites'
                  />
                </Form.Group>
              </Col>
            </Row>
            {isScopeDefined && (
              <>
                <hr />
                <ExecutionScopeForm
                  values={formData}
                  setFieldValue={handleAdvanceFilters}
                  isPlatformRequired={false}
                />
              </>
            )}
          </Container>
        </Form>
      )}
    </div>
  );
};

export default TestCaseFilterForm;
